<header class="navbar navbar-expand align-items-center" [ngClass]="{'d-none':isGameActivity, 'd-flex':!isGameActivity}">
    <!-- <a class="mr-4" qid="cHeader-8" href="javascript:void(0);" *ngIf="!previewMode" (click)="navigateBack()">
        <i class="fa fa-angle-left back-icon"></i>
    </a> -->
    <a class="navbar-brand mr-auto" qid="cHeader-10" href="javascript:void(0);" (click)="closeActivity(true)" [attr.aria-label]="'SHARED._COMMON_ACROSS_PAGES.HEADER.SCREEN_READER.CAMBRDIGE_LOGO' | translate">
        <img src="{{imagesBasePath}}assets/img/cambridge-logo.png" [attr.data-src-2x]="imagesBasePath+'assets/img/cambridge-logo-2x.png'" srcset="{{imagesBasePath}}assets/img/cambridge-logo.png 1x, {{imagesBasePath}}assets/img/cambridge-logo-2x.png 2x" class="brand-img" alt="{{ 'SHARED._COMMON_ACROSS_PAGES.HEADER.SCREEN_READER.CAMBRDIGE_LOGO' | translate }}" />
    </a>
    <h1 class="open-sidebar mr-auto" title="{{selectedActivity?.name}}" [innerHTML]="selectedActivity?.name">
    </h1>
    <div class="d-flex align-items-center navbar-nav close-activity" *ngIf="!previewMode">
        <button type="button" class="close ml-auto" aria-label="Close Activity" qid="cHeader-8" (click)="closeActivity()" #closeActivityBtn>
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</header>

<div class="content-container"
    [ngClass]="{'h-100':isGameActivity}"
    [hidden]="showResultScreen">
    <div class="activity-container h-100">
        <router-outlet></router-outlet>
    </div>
</div>
